import { createAction } from 'redux-act';
/**
 * add info about a discovered game
 */
export const addDiscoveredGame = createAction("ADD_DISCOVERED_GAME", (id, result) => ({ id, result }));
// undiscover game that's no longer found
export const clearDiscoveredGame = createAction("UNDISCOVER_GAME", (id) => ({ id }));
/**
 * override the path of a game that's already been discovered
 */
export const setGamePath = createAction("SET_GAME_PATH", (gameId, gamePath, store, exePath) => ({
    gameId,
    gamePath,
    store,
    exePath,
}));
/**
 * add info about a discovered tool
 */
export const addDiscoveredTool = createAction("ADD_DISCOVERED_TOOL", (gameId, toolId, result, manual) => ({ gameId, toolId, result, manual }));
/**
 * set visibility of a tool. Tools that have been added by the user will be removed entirely whereas
 * discovered tools (those where we have code to discover them) are merely hidden
 */
export const setToolVisible = createAction("SET_TOOL_VISIBLE", (gameId, toolId, visible) => ({
    gameId,
    toolId,
    visible,
}));
/**
 * change parameters for a game (i.e. call arguments, environment, ...)
 */
export const setGameParameters = createAction("SET_GAME_PARAMETERS", (gameId, parameters) => ({ gameId, parameters }));
/**
 * hide or unhide a game
 */
export const setGameHidden = createAction("SET_GAME_HIDDEN", (gameId, hidden) => ({ gameId, hidden }));
export const setGameSearchPaths = createAction("SET_GAME_SEARCH_PATHS", (paths) => paths);
export const setPickerLayout = createAction("SET_GAMEPICKER_LAYOUT", (layout) => ({ layout }));
export const setSortManaged = createAction("SET_SORT_MANAGED", (order) => order);
export const setSortUnmanaged = createAction("SET_SORT_UNMANAGED", (order) => order);
